import { devLog } from '../../../utils';

interface DocumentElementWithFullscreen extends HTMLElement {
  webkitRequestFullscreen?: () => void;
  webkitExitFullscreen?: () => void;
  exitFullscreen?: () => void;
}

export function toggleFullscreen(isFullscreen: boolean, elementId: string) {
  const mainElement = document.getElementById(elementId) as DocumentElementWithFullscreen;
  if (!mainElement) return;

  if (!isFullscreen) {
    if (mainElement.requestFullscreen) {
      mainElement.requestFullscreen();
    } else if (mainElement.webkitRequestFullscreen) {
      mainElement.webkitRequestFullscreen();
    }
  }

  if (isFullscreen) {
    document.exitFullscreen();
  }
}

/**
 * Sends an error to NewRelic with a consistent structure for player errors, including custom fields for better tracking and analysis.
 * Also logs the error message using devLog for local debugging.
 * @param message - The error message to log.
 * @param customFields - Additional custom fields to include in the NewRelic error report.
 * @param category - The category for the error, defaulting to 'player-error'.
 */
export function sendErrorToNewRelic({
  message,
  customFields,
  category = 'player-error',
}: {
  message: string;
  customFields?: Record<string, any>;
  category?: string;
}) {
  devLog(`Viewer Error: ${message}`);
  window.newrelic?.noticeError?.(new Error(message), {
    category,
    ...customFields,
  });
}
